import { LiquidationAsset } from '../coinLiquidation/types';
import { TypeLiquidation } from '../coinLiquidation/types';

export interface TokenWithChain extends LiquidationAsset {
  chainId: string;
  chainName: string;
}

export const canSelectToken = (token: LiquidationAsset, nativeLockUsd: number): boolean => {
  if (!token.isNative) return true;
  const usdValue = Number(token.USDBalance) || 0;
  return usdValue >= nativeLockUsd;
};

export const getAllTokens = (
  typeLiquidation: TypeLiquidation,
  globalLiquidationData: Record<string, unknown>,
  customLiquidation: Record<string, unknown>
): TokenWithChain[] => {
  const tokens: TokenWithChain[] = [];
  const data = typeLiquidation === TypeLiquidation.GLOBAL ? globalLiquidationData : customLiquidation;

  Object.keys(data).forEach(chainId => {
    const chainData = data[chainId];
    if (typeof chainData === 'object' && chainData !== null) {
      Object.keys(chainData).forEach(key => {
        if (key !== 'name' && key !== 'isSelected' && typeof chainData[key] === 'object') {
          const token = chainData[key] as LiquidationAsset;
          const hasValue =
            Number(token.USDBalance) > 0 ||
            Number((token as any).balance) > 0 ||
            Number((token as any).balanceString) > 0 ||
            Number((token as any).stringBalance) > 0;
          if (token.isSelected && hasValue) {
            tokens.push({
              ...token,
              chainId,
              chainName: token.network?.name || chainId
            });
          }
        }
      });
    }
  });

  return tokens;
};
